module.exports = __webpack_public_path__ + "static/media/country_pa.f968087f.webp";